import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const InspectorRelationshipRecord = Record({
  id: null,
  subject: null,
  object: null,
  objectLabel: null,
  objectIsAlive: false,
  objectAge: null
});

createFromJS.registerCallback(
  "InspectorRelationshipRecord",
  createFromJS.createPrimitiveCallback(InspectorRelationshipRecord)
);
